function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { ChevronLeftIcon, ChevronRightIcon } from '@domain-group/fe-co-icon';
import logEventForComponent from '../../utils/log-event-for-component';
import NavigationButton from './navigation-button';
import { jsx as ___EmotionJSX } from "@emotion/core";
var logEvent = logEventForComponent('Navigation');
var Navigation = _ref => {
  var onLeft = _ref.onLeft,
    onRight = _ref.onRight,
    visible = _ref.visible;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hovering = _useState2[0],
    setHovering = _useState2[1];
  var active = visible || hovering;
  var handleEnter = _ref2 => {
    var pointerType = _ref2.pointerType;
    if (pointerType === 'mouse') {
      setHovering(true);
    }
  };
  var handleExit = () => {
    setHovering(false);
  };
  return ___EmotionJSX(Fragment, null, ___EmotionJSX(NavigationButton, {
    onPointerLeave: logEvent('onPointerLeave', handleExit),
    onPointerEnter: logEvent('onPointerEnter', handleEnter),
    align: "left",
    visible: active,
    icon: ___EmotionJSX(ChevronLeftIcon, null),
    onClick: onLeft
  }), ___EmotionJSX(NavigationButton, {
    onPointerLeave: logEvent('onPointerLeave', handleExit),
    onPointerEnter: logEvent('onPointerEnter', handleEnter),
    align: "right",
    visible: active,
    icon: ___EmotionJSX(ChevronRightIcon, null),
    onClick: onRight
  }));
};
Navigation.propTypes = {
  onLeft: PropTypes.func,
  onRight: PropTypes.func,
  visible: PropTypes.bool
};
Navigation.defaultProps = {
  onLeft: () => {},
  onRight: () => {},
  visible: false
};
export default Navigation;